import $ from "jquery";

export const updateStatusBarTime = () => {
  const $timeElement = $(".js-live-time");
  if ($timeElement.length === 0) return;

  const now = new Date();
  let hours = now.getHours();
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  $timeElement.text(`${hours}:${minutes} ${ampm}`);
};
